import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Grid, CircularProgress, Alert } from "@mui/material";
import { Router } from "@mui/icons-material";
import DevicesTable from "../components/Tables/DevicesTable";
import DevicesGraph from "../components/Graphs/DevicesGraph";
import PageTitle from "../components/Layout/PageTitle";
import AddDeviceButton from "../components/Buttons/AddDeviceButton";
import CardInfo from "../components/Cards/CardInfo";
import TotalDevicesThisYear from "../components/Graphs/TotalDevicesThisYear";
import { useDevices } from "../hooks/useDevices";

function Devices() {
  const { data: devices, isLoading, error, isError } = useDevices();

  if (isLoading) {
    return (
      <Grid container spacing={1} justifyContent="center">
        <Grid item xs={12} textAlign="center">
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  if (isError) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Alert severity="error">
            Failed to load devices: {error?.message || "Unknown error"}
          </Alert>
        </Grid>
      </Grid>
    );
  }

  const devicesAddedToday =
    devices?.filter((device) => {
      let time_created = new Date(device.time_created);
      let now = new Date();
      return now.getTime() - time_created.getTime() < 24 * 60 * 60 * 1000;
    })?.length || 0;

  const devicesAddedThisWeek =
    devices?.filter((device) => {
      let time_created = new Date(device.time_created);
      let now = new Date();
      return now.getTime() - time_created.getTime() < 7 * 24 * 60 * 60 * 1000;
    })?.length || 0;

  const devicesAddedThisMonth =
    devices?.filter((device) => {
      let time_created = new Date(device.time_created);
      return (
        time_created.getMonth() === new Date().getMonth() &&
        time_created.getFullYear() === new Date().getFullYear()
      );
    })?.length || 0;

  return (
    <Grid container spacing={1}>
      <PageTitle title="Devices">
        <AddDeviceButton />
      </PageTitle>
      <Grid item xs={12} sm={6}>
        <DevicesGraph dateLength={30} />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TotalDevicesThisYear />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
        <CardInfo
          avatar={<Router sx={{ fontSize: "4em" }} />}
          title="Total Devices"
          value={devices?.length || 0}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
        <CardInfo
          avatar={<Router sx={{ fontSize: "4em" }} />}
          title="Devices Added Today"
          value={devicesAddedToday}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
        <CardInfo
          avatar={<Router sx={{ fontSize: "4em" }} />}
          title="Devices Added This Week"
          value={devicesAddedThisWeek}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
        <CardInfo
          avatar={<Router sx={{ fontSize: "4em" }} />}
          title="Devices Added This Month"
          value={devicesAddedThisMonth}
        />
      </Grid>
      <Grid item xs={12}>
        <DevicesTable devices={devices} />
      </Grid>
    </Grid>
  );
}

export default withAuthenticationRequired(Devices);
